module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyValue),
      expression: "proxyValue"
    }],
    attrs: {
      "type": "hidden",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.proxyValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proxyValue = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0454d2f7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/HiddenInput.vue
// module id = 1224
// module chunks = 2